import * as React from 'react';

import { getDisplayName } from 'components/hoc';
import { HistoryType } from 'types/withRouter';

type WithHistoryBackReceivePropsType = {
	history: HistoryType;
};

export type WithHistoryBackPropsType = {
	onBackFromDetail: () => void;
};

/*
 * Enable history back for card details in favorites view
 * @see FavoritesDetailView
 * @requires withRouter
 * @param {React.Component} WrappedComponent
 */
export default function withHistoryBack<P extends object>(WrappedComponent: React.ComponentType<P>) {
	return class HistoryBackProxy extends React.Component<P & WithHistoryBackReceivePropsType> {
		public static displayName = `withHistoryBack(${getDisplayName(WrappedComponent)})`;

		public render() {
			return <WrappedComponent onBackFromDetail={this.props.history.goBack} {...this.props} />;
		}
	};
}
